import { Stat } from '@/components/ui/Stat';
import { useBillingOverview } from '@/hooks/useAdminBilling';
import { formatCurrency, formatPercentage } from '@/utils/formatters';
import { Euro, TrendingUp, UserMinus, Users } from 'lucide-react';
import { RevenueChart } from '../components/RevenueChart';
import { FailedPaymentsTable } from '../components/FailedPaymentsTable';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function BillingOverviewPage() {
  const { data } = useBillingOverview();
  // Billing overview API returns { mrr, arr, churn, ... } directly (not wrapped in data)
  const o = data;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Facturation</h1>
          <p className="text-sm text-neutral-500">Vue d'ensemble financière</p>
        </div>
        <div className="flex gap-2">
          <Link to="/billing/invoices"><Button variant="outline" size="sm">Factures</Button></Link>
          <Link to="/billing/pricing"><Button variant="outline" size="sm">Tarification</Button></Link>
          <Link to="/billing/revenue"><Button variant="outline" size="sm">Analytique</Button></Link>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="MRR" value={o ? formatCurrency(o.mrr) : '--'} trend={o?.mrrGrowth} icon={<Euro className="h-5 w-5" />} />
        <Stat label="ARR" value={o ? formatCurrency(o.arr) : '--'} icon={<TrendingUp className="h-5 w-5" />} />
        <Stat label="Churn" value={o ? formatPercentage(o.churn) : '--'} icon={<UserMinus className="h-5 w-5" />} />
        <Stat label="Abonnements actifs" value={o?.activeSubscriptions ?? '--'} icon={<Users className="h-5 w-5" />} />
      </div>

      <RevenueChart />

      <div>
        <h2 className="mb-3 text-sm font-semibold text-neutral-600 dark:text-neutral-300">Paiements échoués</h2>
        <FailedPaymentsTable />
      </div>
    </div>
  );
}
